import React, { ReactElement, useCallback } from 'react';
import isEqual from 'lodash.isequal';
import { isServer } from 'b2b-apps/shop/common/utils/env';
import { getCookie, setCookie } from 'b2b-apps/shop/common/utils/storage/cookies';
import { config } from 'b2b-apps/shop/config';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const COOKIE_NAME = 'cookiesEnabled';
const COOKIE_TTL = 365;

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const cookieValue = getCookie(COOKIE_NAME);
    const isVisible = config.features.cookieBanner
      && !isServer
      && cookieValue === null;

    const handleAccept = useCallback(() => {
      setCookie(COOKIE_NAME, true, COOKIE_TTL);
    }, []);

    const t = useTranslate();
    const text = {
      acceptMessage: t('Accept'),
      rejectMessage: t('Reject'),
      message: t(
        '<b>We use cookies</b> to personalize content, improve your experience and analyze web traffic. Read more: <a href="#" class="cds-Link">terms and conditons</a> · <a href="#" class="cds-Link">data protection</a>',
      ),
    };

    const injectedProps: InjectedProps = {
      isVisible,
      onAccept: handleAccept,
      text,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};
